export default "__VITE_ASSET__CyvHVFqX__"